import React, { useEffect, useState, useRef } from "react";
import Attachments from "./modals/Attachments";
import Skeleton from "react-loading-skeleton";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EditIcon } from "../assets/Icons";
import Select from "react-select";
import { useSelector } from "react-redux";
import axios from "axios";

const UserResponseList = ({}) => {
  const { responseId } = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachment, setAttachment] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState({});
  const [dragEnabled, setDragEnabled] = useState(false);
  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const [orderDirty, setOrderDirty] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);
  const [savedOrder, setSavedOrder] = useState([]);

  const fetchQestions = async () => {
    try {
      let { data } = await axios.get(`${configData.config.API_URL}/api/site/response/${responseId}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setQuestions(data.data);
      setSiteOptions(data.data.subSiteList?.map((item) => ({ label: item.name, value: item.uuid })));
      setSelectedSite({ label: data?.data?.site?.name, value: data?.data?.site?.uuid });
      setSavedOrder(data.data.data.map((q) => q.uniqueKey));
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleResponseChange = (uniqueKey, responseId, answer) => {
    const ques = questions?.data;
    ques.forEach((item) => {
      if (item.uniqueKey == uniqueKey) {
        item.responseId = responseId;
        item.answer = answer;
      }
    });
    setQuestions((prev) => ({ ...prev, data: ques }));
  };

  const handleView = (data) => {
    setAttachment(data);
    setShowAttachments(true);
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const filteredRes = questions?.data?.map(({ uniqueKey, options, ...rest }) => rest);

      await axios.post(
        `${configData.config.API_URL}/api/application/response/update`,
        { data: filteredRes, siteId: selectedSite.value, responseId: responseId },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        },
      );
    } catch (error) {
      console.log(error.message);
    } finally {
      setSaving(false);
      fetchQestions();
    }
  };

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setEditingId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchQestions();
  }, []);
  const onDragStartRow = (id) => (e) => {
    if (!dragEnabled) return;
    setDraggingId(id);

    e.dataTransfer.effectAllowed = "move"; // ADD THIS
  };

  const onDragOverRow = (id) => (e) => {
    if (!dragEnabled) return;
    e.preventDefault();
    setDragOverId(id);
  };
  const saveOrderData = async () => {
    try {
      setSavingOrder(true);

      const payload = questions.data.map((q, index) => ({
        ...q,
        priority: index + 1,
      }));

      await axios.post(`${configData.config.API_URL}/api/machine/update/priority-responses/${responseId}`, payload, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      setSavedOrder(payload.map((q) => q.uniqueKey));
      setOrderDirty(false);
      setDragEnabled(false);
    } catch (err) {
      console.log(err);
    } finally {
      setSavingOrder(false);
    }
  };
  const onDropRow = (targetId) => (e) => {
    if (!dragEnabled) return;
    e.preventDefault();
    if (!draggingId || draggingId === targetId) {
      setDraggingId(null);
      setDragOverId(null);
      return;
    }

    const updated = [...questions.data];
    const fromIndex = updated.findIndex((q) => q.uniqueKey === draggingId);
    const toIndex = updated.findIndex((q) => q.uniqueKey === targetId);

    if (fromIndex === -1 || toIndex === -1) return;

    const [moved] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, moved);

    setQuestions((prev) => ({ ...prev, data: updated }));
    setOrderDirty(true);
    setDraggingId(null);
    setDragOverId(null);
  };

  const onDragEndRow = () => {
    setDraggingId(null);
    setDragOverId(null);
  };
  const revertToSavedOrder = () => {
    const map = new Map(questions.data.map((q) => [q.uniqueKey, q]));

    const ordered = savedOrder.map((id) => map.get(id)).filter(Boolean);

    setQuestions((prev) => ({
      ...prev,
      data: ordered,
    }));

    setOrderDirty(false);
  };
  return (
    <>
      
      <div className="d-flex gap-2 justify-content-end">
        <div className="d-flex gap-2 justify-content-end">
        {!dragEnabled ? (
          <button
            className="btn btn-danger"
            onClick={() => setDragEnabled(true)}
            disabled={questions?.data?.length < 2}
          >
            Rearrange Responses
          </button>
        ) : (
          <>
            <button
              className="btn btn-secondary"
              onClick={() => {
                revertToSavedOrder();
                setDragEnabled(false);
                setDraggingId(null);
                setDragOverId(null);
              }}
            >
              Cancel
            </button>

            <button className="btn btn-danger" onClick={saveOrderData} disabled={!orderDirty || savingOrder}>
              {savingOrder ? "Saving..." : "Save Response Order"}
            </button>
          </>
        )}
      </div>
        {!!siteOptions?.length && (
          <div style={{ width: "170px" }}>
            <Select
              options={siteOptions}
              value={selectedSite}
              onChange={(e) => setSelectedSite(e)}
              placeholder="Select a site"
            />
          </div>
        )}
        {userData?.user?.permissions?.includes("MACHINE.ADD") && !loading && (
          <button className="btn btn-danger d-flex align-items-center gap-2" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <div className="spinner-border spinner-border-sm"></div>
                Saving...
              </>
            ) : (
              "Save"
            )}
          </button>
        )}

      </div>
      <div className="table-responsive workflowtb mt-3">
        <table className="table align-middle table-nowrap mb-0">
          <thead>
            <tr>
              <th className="text-center">S.No.</th>
              <th>Question</th>
              <th className="text-center">Response</th>
              <th className="text-center">Selected List Option</th>
              <th className="text-center">Attachments</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <>
                <tr>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td>
                    <Skeleton width="20vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="8vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                </tr>
                <tr>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td>
                    <Skeleton width="20vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="8vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                </tr>
                <tr>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td>
                    <Skeleton width="20vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="8vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                </tr>
              </>
            ) : (
              <>
                {questions.data?.length > 0 &&
                  questions.data.map((e, i) => {
                    const formatResponse = (options, answerId) => {
                      const res = options?.find((item) => item.uuid == answerId).option;
                      return res === "Yes" ? (
                        <span className="good">{res}</span>
                      ) : res === "No" ? (
                        <span className="bad">{res}</span>
                      ) : (
                        <span className="other text-muted">{res}</span>
                      );
                    };

                    return (
                      <tr
                        key={e.uniqueKey}
                        draggable={dragEnabled && !savingOrder}
                        onDragStart={onDragStartRow(e.uniqueKey)}
                        onDragOver={onDragOverRow(e.uniqueKey)}
                        onDrop={onDropRow(e.uniqueKey)}
                        onDragEnd={onDragEndRow}
                        className={[
                          dragEnabled ? "is-enabled" : "is-disabled",
                          draggingId === e.uniqueKey ? "is-dragging" : "",
                          dragOverId === e.uniqueKey && draggingId !== e.uniqueKey ? "is-drag-over" : "",
                        ].join(" ")}
                      >
                        <td className="text-center">
                          {dragEnabled && <span style={{ cursor: "grab", marginRight: "6px" }}>⋮⋮</span>}
                          {i + 1}
                        </td>
                        <td>
                          <div className="ques-comment">
                            <span>{e.question}</span>
                            {e.comment && (
                              <span className="comment">
                                {" "}
                                <span> Comment : </span>
                                {e.comment}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="text-center position-relative">
                          {formatResponse(e.options, e.responseId)}
                          <button
                            onClick={() => setEditingId(i)}
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              marginLeft: "8px",
                            }}
                          >
                            <EditIcon />
                          </button>

                          {editingId === i && (
                            <div
                              ref={dropdownRef}
                              className="custom-dropdown-menu"
                              style={{
                                position: "absolute",
                                top: "80%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                zIndex: 999,
                              }}
                            >
                              <div className="dropdown-menu show" style={{ display: "block", minWidth: "90px" }}>
                                {e?.options.map((opt) => (
                                  <button
                                    key={opt.uuid}
                                    className="dropdown-item"
                                    onClick={() => {
                                      setEditingId(null);
                                      handleResponseChange(e.uniqueKey, opt.uuid, opt.option);
                                    }}
                                  >
                                    {opt.option}
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}
                        </td>

                        <td className="text-center">{e.selectedListOptionLabel || "N/A"}</td>

                        <td className="text-center">
                          {e?.attachments?.length > 0 ? (
                            <Link onClick={() => handleView(e.attachments)}>View</Link>
                          ) : (
                            <div>NA</div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
      </div>

      <Attachments showAttachments={showAttachments} setShowAttachments={setShowAttachments} attachment={attachment} />
    </>
  );
};

export default UserResponseList;
